import { UserClaims } from '../../services/authCacheManager.service';

export interface AuthState {
  claims: UserClaims | null;
  error: string | null;
  isAuthenticating: boolean;
  isAuthenticated: boolean;
}

type Action =
  | { type: 'SIGN_IN_STARTED' }
  | { type: 'SIGN_IN_FAILED'; payload: { error: string } }
  | { type: 'SET_USER_SUCCESS'; payload: { claims: UserClaims } }
  | { type: 'SIGN_OUT' };

export const authReducer = (state: AuthState, action: Action): AuthState => {
  switch (action.type) {
    case 'SIGN_IN_STARTED':
      return {
        ...state,
        error: null,
        isAuthenticating: true,
      };

    case 'SET_USER_SUCCESS':
      return {
        ...state,
        claims: action.payload.claims,
        isAuthenticated: !!action.payload.claims.userId,
        isAuthenticating: false,
      };

    case 'SIGN_OUT':
      return {
        ...state,
        claims: null,
        isAuthenticated: false,
        isAuthenticating: false,
      };

    case 'SIGN_IN_FAILED': {
      return { ...state, error: action.payload.error };
    }

    default:
      return state;
  }
};
